<template>
    <b-card no-body>
        <v-table    ref="table"
                    :items="reports"
                    with-items
                    :fields="fields"
                    name="seyir-performance"
                    pagination="client">
                    <template #additional-actions>
                        <div class="row">
                            <div class="col-md-3 mb-1 mb-md-0">
                                <v-date-picker v-model="date" placeholder="Tarih Seçiniz"></v-date-picker>
                            </div>
                            <div class="col-md-3 mb-1 mb-md-0">
                                <v-date-picker v-model="hour" range type="time" only-hour placeholder="Saat Aralığı Seçiniz"></v-date-picker>
                            </div>
                            <div class="col-md-auto mb-1 mb-md-0">
                                <button class="btn btn-success w-100" v-on:click="getReports">
                                    Sorgula
                                </button>
                            </div>
                        </div>
                    </template>
        </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import SeyirApi from '@/api/seyir'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
    },
    data(){
        return{
            date:null,
            hour:[],
            fields:Additional.ConvertAutoTable([
                "vehicle",
                "trailer",
                "date",
                "km",
                "drive_time",
                "hour_start",
                "hour_end",
                "device_id",
                "idle_fuel",
                "idle_time",
                "total_fuel",
                "work_time",
                "diffgrid",
                "msdatarowOrder",
            ],[],'text-nowrap'),
            reports:[]
        }
    },
    methods:{
        getReports(){
            if(this.date && this.hour[0] && this.hour[1]){
                this.$refs.table.setLoading(true)
                const startHour = Number(this.hour[0]) || 0
                const endHour = Number(this.hour[1]) || 1
                SeyirApi.GetPerformanceReport(this.date,startHour,endHour).then(res=>{
                    this.$refs.table.setLoading(false)
                    if(res.data.Success){
                        this.reports = res.data.Data || []
                    }else this.$result(res)
                })
            }
        }
    }
}
</script>

<style>

</style>